


































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import RegionEdit from '@/components/Settings/Regions/RegionEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'RegionDetails', components: { RegionEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get region() {
        return RegionsModule.region;
    }

    get workingDays() {
        const workingDays = this.region.workingDays;
        let daysList = [];
        for (const day in workingDays) {
            if ((workingDays as any)[day]) {
                daysList.push({ id: day, name: day.toLowerCase() });
            }
        }
        return daysList;
    }

    get nonWorkingDays() {
        const workingDays = this.region.workingDays;
        let daysList = [];
        for (const day in workingDays) {
            if (!(workingDays as any)[day]) {
                daysList.push({ id: day, name: day.toLowerCase() });
            }
        }
        return daysList;
    }

}
